import { createRootRoute, Outlet } from '@tanstack/react-router';
import { SessionExpiryBanner } from '@/components/SessionExpiryBanner';
import { I18nProvider } from '@/i18n';
import { LocaleProvider, LocaleToggle } from '@/i18n/locale';

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <LocaleProvider>
      <I18nProvider>
        {/* flex column so the full-height LMS shell can flex-1 below the (rare) expiry banner */}
        <div className="flex min-h-dvh flex-col">
          <SessionExpiryBanner />
          <Outlet />
        </div>
        <LocaleToggle />
      </I18nProvider>
    </LocaleProvider>
  );
}
